<template>
  <base-content :loading="isPending" mobile-tabled>
    <template v-slot:top>
      <hero-header centered heading="Statement" />
    </template>
    <template v-if="ready">
      <base-card tabled-mobile>
        <template v-slot:body-top>
          <base-card-title>General Investment Account (GIA)</base-card-title>
        </template>
        <template v-if="accounts.gia">
          <account-statement :account="accounts.gia" />
        </template>
        <template v-else>
          <p>
            You have no statements to view yet.
          </p>
        </template>
      </base-card>
    </template>
    <template v-else>
      <base-loader />
    </template>
  </base-content>
</template>

<script>
import { mapState } from 'vuex'

import AccountStatement from '@/components/AccountStatement.vue'
import HeroHeader from '@/components/HeroHeader.vue'

export default {
  components: {
    AccountStatement,
    HeroHeader
  },

  metaInfo: {
    title: 'Statement'
  },

  data: () => ({
    account: null,
    accounts: {
      gia: {},
      isa: {}
    },
    ready: false
  }),

  async created () {
    await this.$store.dispatch('core/accounts/all', {
      query: {
        user: this.$auth.user._id
      }
    })

    this.accounts.gia = this.userAccounts.find(({ alias }) => alias === 'gia') || null
    this.accounts.isa = this.userAccounts.find(({ alias }) => alias === 'isa') || null

    this.ready = true
  },

  computed: {
    ...mapState({
      isPending: store => store.core.accounts.isAllPending,
      userAccounts: store => store.core.accounts.all
    })
  }
}
</script>
